import React from 'react';
import { Box, Paper, styled } from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(2),
  minHeight: '842px', // A4 height
  width: '595px', // A4 width
  backgroundColor: '#fff',
  fontSize: '12px',
  lineHeight: 1.4,
  '*': {
    fontFamily: 'Times New Roman, serif',
  },
  '& .MuiTypography-root': {
    fontSize: '12px',
    lineHeight: 1.4,
  },
  '& p': {
    margin: '0.3em 0',
    whiteSpace: 'pre-wrap',
    minHeight: '1.2em',
  },
  '& h2': {
    color: '#1976d2',
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginBottom: '1rem',
    fontSize: '14px',
  },
  '& h3': {
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    fontSize: '13px',
  },
  '& .action-items-intro': {
    marginBottom: '1rem',
    fontStyle: 'italic',
  },
  '& .action-item': {
    marginBottom: '0.5rem',
    paddingLeft: '1rem',
  },
  '& img.company-logo, & img[alt="CD Construction Consulting"]': {
    width: '150px !important',
    height: 'auto !important',
    display: 'block !important',
    margin: '0 auto 2rem auto !important',
    maxWidth: '150px !important',
  },
}));

interface ExecutiveSummaryPreviewProps {
  executiveSummary: string;
  actionItems: string;
}

const ExecutiveSummaryPreview: React.FC<ExecutiveSummaryPreviewProps> = ({ executiveSummary, actionItems }) => {
  return (
    <StyledPaper elevation={2}>
      <Box>
        {/* Executive Summary Section */}
        <div dangerouslySetInnerHTML={{ __html: executiveSummary }} />

        {/* Action Items moved to its own tab/page (kept prop for backward compatibility) */}
        {false && actionItems && <div dangerouslySetInnerHTML={{ __html: actionItems }} />}
      </Box>
    </StyledPaper>
  );
};

export default ExecutiveSummaryPreview;
